import React from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import BackgroundImage from 'gatsby-background-image'

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import Header from "./../../../components/header"
import ListItem from "./../../../components/ListItem"
import BadgeItem from "./../../../components/BadgeItem"
import BackButton from "./../../../components/BackButton"
import Album from "./../../../components/Album"

export default function RoiGradlon({ data }) {
  return (
    <Layout>
      <Header title="Retour" href="/estacades" />
      <SEO title="Roi Gradlon" />

      <BackgroundImage
        className="banner"
        fluid={[
          'linear-gradient(transparent, #101010 90%)',
          data.bg.childImageSharp.fluid,
        ]}
      >
        <h1>Roi Gradlon</h1>
      </BackgroundImage>

      <p>
        Construit en 1948 au Havre, ce navire emblématique était affecté depuis 1952 à Lorient et chargé de l’entretien des phares et balises dans les eaux du Morbihan, de la Laïta à la Vilaine. Après 66 ans de travail, dont 62 ans au sein de l’Armement des phares et balises, le Roi Gradlon a été dé- sarmé en 2014.
      </p>

      <BadgeItem
        to="https://www.port-musee.org/scan3D/ROI_GRADLON_machine/roigradlon.html"
        img={data.pano}
        title="Visite virtuelle"
        subtitle="Salle des machines"
      />
      <BadgeItem
        to="https://vimeo.com/183461779"
        img={data.arrivee2015}
        title="L’arrivée au Port-Musée"
        subtitle="Archives — Avril 2015"
      />
      <Album slides={data.photos} />

      <BackButton />
    </Layout>
  )
}

export const query = graphql`
  query {
    bg: file(relativePath: { eq: "estacades/roi-gradlon/a.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    pano: file(relativePath: { eq: "estacades/roi-gradlon/pano.jpg" }) {
      ...BadgeImage
    }
    arrivee2015: file(relativePath: { eq: "estacades/roi-gradlon/arrivee2015.jpg" }) {
      ...BadgeImage
    }
    photos: allFile(
      filter: {relativeDirectory: {regex: "/estacades/roi-gradlon/photos/"}},
      sort: {fields: name}
    ) {
      edges {
        node {
          id
          childImageSharp {
            fluid(maxWidth: 360) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
